export const accommodationOptionsEnum = {
    defaultNumberOfOptions: 3
}
